
export interface Cancelable {
    clear(): void;
}

export function debounce<T extends (...args: any[]) => any>(func: T, wait: number = 166): T & Cancelable {
    let timeout: number;
    function debounced(...args: any[]) {
        const later = () => {
            /* @ts-ignore */
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait) as unknown as number;
    }
    debounced.clear = () => {
        clearTimeout(timeout);
    };
    return debounced as unknown as T & Cancelable;
}
